import React from 'react';
import { Row, Col, Form } from 'antd';
import { I18n } from '@aws-amplify/core';
import { useSectionActionPlan } from './context';
import * as S from './styles';

const { useWatch } = Form;

interface FooterProps {
	onClick(): void;
	isEditing: boolean;
}

export function Footer({ isEditing, onClick }: Readonly<FooterProps>) {
	const { form_field_name: formFieldName } = useSectionActionPlan();

	const title = useWatch([...formFieldName, 'title']);
	const deadline = useWatch([...formFieldName, 'deadline']);
	const responsible_id = useWatch([...formFieldName, 'responsible_user_id']);
	const isFieldsFilled = !!title && !!deadline && !!responsible_id;

	return (
		<Row justify="center">
			<Col>
				<S.GenerateButton type="primary" disabled={!isFieldsFilled} onClick={onClick}>
					{isEditing ? I18n.get('Edit action plan') : I18n.get('Generate action plan')}
				</S.GenerateButton>
			</Col>
		</Row>
	);
}
